import cinemaInjector from './cinemaInjector'
import cinemaClient from './cinemaClient'

import debug from '../qa/debug';

const SPONSORED_ARTICLES_CINEMA_IDENTIFIER = 'sponsoredArticlesCinema';

export default (data) => {
    if (!data.sponsoredArticlesCinemaTarget) {
        return Promise.resolve();
    }

    return cinemaClient.loadDetailViewCinema(data.variationId)
        .then((response) => {
            debug.log("data = " + data);

            if (!!response[SPONSORED_ARTICLES_CINEMA_IDENTIFIER] && !!data.sponsoredArticlesCinemaTarget) {
                const targetElement = document.querySelector(data.sponsoredArticlesCinemaTarget);
                if (targetElement) {
                    cinemaInjector.injectCinema(targetElement, response[SPONSORED_ARTICLES_CINEMA_IDENTIFIER], data.eventMergeId);
                } else {
                    debug.log("could not find target for sponsored cinema css selector " + data.sponsoredArticlesCinemaTarget);
                }
            }
        })
        .catch((error) => {
            debug.log(error);
        });
};